<template>
  <div class="enroll pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="bookBox-1 mtb2">
        <el-form ref="enrollForm" :model="enrollForm" :rules="enrollRules">
          <h2>常用联系人列表<span @click="dialogFormVisible = true">新增联系人</span></h2>
          <div class="">
            <el-form-item v-if="userdata && userdata.length>0" prop="contactIds">
              <el-checkbox-group v-model="enrollForm.contactIds" @change="changeContactIds(userdata)">
                <el-checkbox :label="user.id" name="contactIds" v-for="(user, index) in userdata" :key="index">{{ user.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="">
            <el-table
              :data="tableData"
              header-row-class-name="headerrow"
              style="width: 100%">
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="idNo" label="证件号"></el-table-column>
              <el-table-column prop="cellphone" label="手机号" ></el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleClick(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mt20" v-if="sessionData.length > 0">
            <h2>场次信息</h2>
            <div class="sessionTable">
              <el-table
                ref="sessionTable"
                :data="sessionData"
                header-row-class-name="headerrow"
                @select="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="140">
                </el-table-column>
                <el-table-column prop="sessionName" label="场次名称"></el-table-column>
                <el-table-column prop="countSurplus" label="余票"></el-table-column>
                <el-table-column prop="countLimit" label="票数"></el-table-column>
                <el-table-column prop="startTime" label="开始时间"></el-table-column>
                <el-table-column prop="endTime" label="结束时间"></el-table-column>
              </el-table>
            </div>
          </div>
          <div class="infobox mt20 clearfix">
            <div class="itembox">
              <h2>活动信息</h2>
              <ul class="ul-form1">
                <li>
                  <label>活动名称：</label>
                  <span class="textover">{{ appointmentdetail.name }}</span>
                </li>
                <li>
                  <label>活动时间：</label>
                  <span>{{ getTime(appointmentdetail.beginTime) }} 至 {{ getTime(appointmentdetail.endTime) }}</span>
                </li>
                <li v-if="appointmentdetail.address">
                  <label>活动地点：</label>
                  <span class="textover">{{ appointmentdetail.address }}</span>
                </li>
              </ul>
            </div>
            <div class="itembox">
              <h2>报名信息</h2>
              <ul class="ul-form1">
                <li>
                  <label>已预订票数：</label>
                  <span class="textover"> {{ enrollNumber }}张</span>
                </li>
<!--                <li>-->
<!--                  <label>参加原因：</label>-->
<!--                  <el-form-item>-->
<!--                    <el-input v-model="enrollForm.content" placeholder="请输入参加原因"></el-input>-->
<!--                  </el-form-item>-->
<!--                </li>-->
                <li>
                  <label>验证码：</label>
                  <el-form-item class="codeimg" prop="verCode">
                    <i class="icon icon3"></i>
                    <el-input v-model="enrollForm.verCode" placeholder="验证码"></el-input>
                    <img :src="picCode" alt="" @click="getPicCode">
                  </el-form-item>
                </li>
              </ul>
            </div>
          </div>
          <div class="descbox">
            <h2>{{ appointmentdetail.tip2Name }}</h2>
            <div class="con" v-html="appointmentdetail.tip2Value"></div>
            <el-form-item prop="accept">
              <el-checkbox-group v-model="enrollForm.accept" @change="bookbtnchange()">
                <el-checkbox label="我已阅读并接受订票须知相关条款。" name="accept"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <el-button class="bookbtn style1" :class="{ 'on': confirmbtnFlag }" @click="dialogComplete">我要报名</el-button>
        </el-form>
        <el-dialog title="新增联系人信息" :visible.sync="dialogFormVisible" center :width="addformWidth">
          <el-form ref="contactsForm" :model="contactsForm" :rules="contactsRules" label-position="left" label-width="70px">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="contactsForm.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="cellphone">
              <el-input v-model="contactsForm.cellphone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="idNo">
              <el-input v-model="contactsForm.idNo" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button class="bookbtn" @click="addContacts">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="报名成功" :visible.sync="dialogCompleteVisible" center :width="completeWidth">
          <div class="detailform1 clearfix">
            <div class="imgbox fl">
              <img src="https://cultureclouds.chaoxing.com/res/show/9001/images/pic01.jpg" alt="">
            </div>
            <ul class="ul-form1 fr">
              <li>
                <label>活动名称：</label>
                <span class="textover">{{ appointmentdetail.name }}</span>
              </li>
              <li>
                <label>活动时间：</label>
                <span class="textover">{{ getTime(appointmentdetail.beginTime) }} 至 {{ getTime(appointmentdetail.endTime) }}</span>
              </li>
              <li v-if="appointmentdetail.address">
                <label>活动地点：</label>
                <span class="textover">{{ appointmentdetail.address }}</span>
              </li>
              <li>
                <label>此次订票：</label>
                <span class="textover">{{ enrollNumber }}张</span>
              </li>
              <li>
                <label>状态：</label>
                <span class="textover">待参与</span>
              </li>
              <li>
                <label>联系人：</label>
                <span class="textover">{{ enrollbackinfo.name }}</span>
              </li>
              <li>
                <label>联系电话：</label>
                <span class="textover">{{ enrollbackinfo.phone  }}</span>
              </li>
              <li>
                <label>温馨提示：</label>
                <span class="textover color1">现场二维码签到！</span>
              </li>
            </ul>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="gobackdetail">返回活动</el-button>
            <el-button @click="goCenter" class="bookbtn">个人中心</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import {
  getAppointmentDetail,
  getAppointmentContactsList,
  addAppointmentContacts,
  getAppointmentsignUp,
  getAppointmentSession } from '@/api/appointment/index'
import { timeFormat } from '@/utils/validate'
export default {
  name: 'appointmentenroll',
  meta: {
    showHeader: true
  },
  components: {
    crumbs
  },
  data () {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        if (value.length === 6 || value.length === 11) {
          callback()
        } else {
          return callback(new Error('请输入11位或者6位'))
        }
      }
    }
    let IsCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证号不能为空'))
      } else {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证号'))
        }
      }
    }
    return {
      appointmentdetail: '',
      userdata: [],
      tableData: [],
      enrollForm: {
        contactIds: [],
        accept: [],
        verCode: '',
        memberId: this.$cookie.get('wlyuserid')
      },
      enrollRules: {
        contactIds: [{required: true, message: '请勾选联系人', trigger: 'blur'}],
        verCode: [{required: true, message: '验证码不能为空', trigger: 'blur'}],
        accept: [{required: true, message: '请勾选我已阅读并接受相关条款', trigger: 'blur'}]
      },
      confirmbtnFlag: false,
      contactsForm: {
        'name': '',
        'cellphone': '',
        'idNo': '',
        'userName': this.$cookie.get('wlymobilephone'),
        'departmentCode': this.$cookie.get('museumCode')
      },
      contactsRules: {
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        cellphone: [{required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'}],
        idNo: [{required: true, message: '请输入身份证号', validator: IsCard, trigger: 'blur'}]
      },
      dialogFormVisible: false,
      dialogCompleteVisible: false,
      addformWidth: '26%',
      completeWidth: '768px',
      picCode: '',
      enrollNumber: 0,
      sessionData: [],
      sessionId: '',
      enrollbackinfo: {}
    }
  },
  mounted () {
    if (document.body.clientWidth < 768) {
      this.addformWidth = '80%'
      this.completeWidth = '80%'
    } else {
      this.addformWidth = '26%'
      this.completeWidth = '768px'
    }
    this.getDetail()
    this.getPerson()
    this.getPicCode()
    this.getSession()
  },
  methods: {
    /* 获取验证码 */
    getPicCode () {
      this.picCode = process.env.BASE_API + '/api/auth/jwt/getCode?' + new Date().getTime() + '&phone=' + this.$cookie.get('wlymobilephone')
    },
    /* 格式化时间 */
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    /* 获取活动详情 */
    getDetail () {
      getAppointmentDetail(this.$route.query.id).then(res => {
        if (res.data.status === 200) {
          this.appointmentdetail = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取活动场次
    getSession () {
      getAppointmentSession(this.$route.query.id).then(res => {
        if (res.data.data.length > 0) {
          this.sessionData = res.data.data
        }
      })
    },
    // 选择场次
    handleSelectionChange (val, row) {
      this.$refs.sessionTable.clearSelection()
      this.$refs.sessionTable.toggleRowSelection(row, true)
      this.sessionId = row.id
    },
    /* 获取联系人列表 */
    getPerson () {
      getAppointmentContactsList(this.$cookie.get('wlymobilephone'), this.$cookie.get('museumCode')).then(res => {
        // console.log(res)
        if (res.data.status === 200) {
          this.userdata = res.data.data
        }
      })
    },
    /* 新增联系人 */
    addContacts () {
      this.$refs['contactsForm'].validate((valid) => {
        if (valid) {
          addAppointmentContacts(this.contactsForm).then(res => {
            if (res.data.status === 200) {
              this.$message({message: res.data.message, type: 'success', duration: 1500})
              this.dialogFormVisible = false
              this.getPerson()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    /* 获取年龄及性别 */
    getAgeSex (card) {
      let sex = ''
      /* 1 男性 2 女性 */
      if (parseInt(card.substr(16, 1)) % 2 === 1) {
        sex = 1
      } else {
        sex = 2
      }
      let yearBirth = card.substring(6, 10)
      let monthBirth = card.substring(10, 12)
      let dayBirth = card.substring(12, 14)
      let myDate = new Date()
      let monthNow = myDate.getMonth() + 1
      let dayNow = myDate.getDate()
      let age = myDate.getFullYear() - yearBirth
      if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
        age--
      }
      // 得到年龄
      let obj = {sex: sex, age: age}
      return obj
    },
    /* 选择联系人 */
    changeContactIds (val) {
      console.log(val)
      this.tableData = []
      for (let i = 0; i < val.length; i++) {
        for (let j = 0; j < this.enrollForm.contactIds.length; j++) {
          if (this.enrollForm.contactIds[j] === val[i].id) {
            let obj = {
              'id': val[i].id,
              'name': val[i].name,
              'idNo': val[i].idNo,
              'cellphone': val[i].cellphone
            }
            let AgeSexobj = this.getAgeSex(val[i].idNo)
            if (this.appointmentdetail.ageSet.code === 1 && this.appointmentdetail.sexSet.code === 1) {
              if (this.appointmentdetail.sex.code === 0) {
                if (AgeSexobj.sex === 1) {
                  this.ageJudge(AgeSexobj.age, this.appointmentdetail.maleMinAge, this.appointmentdetail.maleMaxAge)
                } else if (AgeSexobj.sex === 2) {
                  this.ageJudge(AgeSexobj.age, this.appointmentdetail.femaleMinAge, this.appointmentdetail.femaleMaxAge)
                }
                this.tableData.push(obj)
              }
              if (this.appointmentdetail.sex.code === 1) {
                if (AgeSexobj.sex === 2) {
                  this.$message.error('活动限男性，所选联系人为女性')
                  return
                }
                this.ageJudge(AgeSexobj.age, this.appointmentdetail.maleMinAge, this.appointmentdetail.maleMaxAge)
                this.tableData.push(obj)
              }
              if (this.appointmentdetail.sex.code === 2) {
                if (AgeSexobj.sex === 1) {
                  this.$message.error('活动限女性，所选联系人为男性')
                  return
                }
                this.ageJudge(AgeSexobj.age, this.appointmentdetail.femaleMinAge, this.appointmentdetail.femaleMaxAge)
                this.tableData.push(obj)
              }
            } else if (this.appointmentdetail.ageSet.code === 1) {
              this.ageJudge(AgeSexobj.age, this.appointmentdetail.minAge, this.appointmentdetail.maxAge)
              this.tableData.push(obj)
            } else {
              this.tableData.push(obj)
            }
          }
        }
      }
      /* 报名数量 */
      this.enrollNumber = this.tableData.length
    },
    /* 判断是否在年龄范围内 */
    ageJudge (age, min, max) {
      if (age < min || age > max) {
        this.$message.error('所选联系人不在年龄范围内')
        return false
      } else {
        return true
      }
    },
    /* 勾选阅读条款 */
    bookbtnchange () {
      if (this.enrollForm.accept.length > 0) {
        this.confirmbtnFlag = true
      } else {
        this.confirmbtnFlag = false
      }
    },
    /* 联系人删除操作 */
    handleClick (val) {
      for (let i = 0; i < this.enrollForm.contactIds.length; i++) {
        if (this.enrollForm.contactIds[i] === val.id) {
          this.enrollForm.contactIds.splice(i, 1)
        }
      }
      for (let j = 0; j < this.tableData.length; j++) {
        if (this.tableData[j].id === val.id) {
          this.tableData.splice(j, 1)
        }
      }
      this.enrollNumber = this.tableData.length
    },
    /* 确定报名 */
    dialogComplete () {
      this.$refs['enrollForm'].validate((valid) => {
        if (valid) {
          /* 报名人数限制 */
          if (this.appointmentdetail.multipleSet.code === 1) {
            if (this.enrollForm.contactIds.length > this.appointmentdetail.multipleNumber) {
              this.$message.error('活动报名人数限定' + this.appointmentdetail.multipleNumber + '人')
              return false
            }
          }
          let enrollparams = {
            'contactsId': this.enrollForm.contactIds.join(','),
            'verCode': this.enrollForm.verCode,
            'activityId': this.$route.query.id,
            'memberId': this.$cookie.get('wlyuserid'),
            'phone': this.$cookie.get('wlymobilephone')
          }
          if (this.sessionId !== '') enrollparams.sessionId = this.sessionId
          getAppointmentsignUp(enrollparams).then(res => {
            if (res.data.rel) {
              this.dialogCompleteVisible = true
              this.enrollbackinfo = res.data.data
              this.sessionId = ''
            } else {
              this.$message.error(res.data.data)
            }
          })
        }
      })
    },
    /* 跳个人中心 */
    goCenter () {
      this.$router.push({path: '/personalcenter'})
    },
    /* 返回活动详情 */
    gobackdetail () {
      this.$router.push({path: '/appointmentdetail', query: {columnId: this.$route.query.columnId, id: this.$route.query.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
.bookBox-1{
  .el-button{
    &.bookbtn.style1{
      opacity: 0.5;
      &.on{
        opacity: 1;
      }
    }
  }
  .sessionTable /deep/ .el-table__header-wrapper > table > thead > tr > th:first-child > div {
    display: none!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/appointment/enroll.vue